module.exports = __webpack_public_path__ + "media/bg3.7b52af52.mp4";